import { ResponseFeedbackOption, ResponseFeedbackReason } from './response-feedback.interface';

export const POSITIVE_FEEDBACK_REASONS: ResponseFeedbackReason[] = [
    {
        displayName: 'Accurate',
        value: 'accurate'
    },
    {
        displayName: 'Relevant',
        value: 'relevant'
    },
    {
        displayName: 'Safe',
        value: 'safe'
    },
    {
        displayName: 'Helpful',
        value: 'helpful'
    },
    {
        displayName: 'Professional',
        value: 'professional'
    },
    {
        displayName: 'Well structured',
        value: 'well_structured'
    },
    {
        displayName: 'Right length',
        value: 'right_length'
    }
];

export const NEGATIVE_FEEDBACK_REASONS: ResponseFeedbackReason[] = [
    {
        displayName: 'Harmful',
        value: 'harmful'
    },
    {
        displayName: 'Not helpful',
        value: 'unhelpful'
    },
    {
        displayName: 'Inaccurate',
        value: 'inaccurate'
    },
    {
        displayName: 'Off topic',
        value: 'off_topic'
    },
    {
        displayName: 'Unprofessional',
        value: 'unprofessional'
    },
    {
        displayName: 'Poorly structured',
        value: 'poorly_structured'
    },
    {
        displayName: 'Not relevant',
        value: 'not_relevant'
    },
    {
        displayName: 'Too short',
        value: 'too_short'
    },
    {
        displayName: 'Too long',
        value: 'too_long'
    }
];

export const FEEDBACK_OPTIONS_CONFIG: () => ResponseFeedbackOption[] = (): ResponseFeedbackOption[] => [
    {
        displayName: 'Yes',
        value: 'yes',
        icon: 'thumbs-up',
        reasons: [...POSITIVE_FEEDBACK_REASONS]
    },
    {
        displayName: 'No',
        value: 'no',
        icon: 'thumbs-down',
        reasons: [...NEGATIVE_FEEDBACK_REASONS]
    },
    {
        displayName: `I don't know`,
        value: 'i_dont_know'
    }
];
